import { Auth } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { RaaSSession, getToken, setStorage, setToken} from './user.session.service';
import { SignInUserSession, SocialTokens } from 'models/LoginSocialInterface';
import { isEmptyObject } from 'services/util/util.service';


/* Public functions */
/**
 * 
 * @param signInUserSession valores de SignInUserSession obtenidos.
 * @returns 
 */
export const initUser = (signInUserSession: SignInUserSession): Promise<any> => {
    const {
        idToken: { jwtToken: deviceKey },
        refreshToken: { token: refreshToken },
        accessToken: { jwtToken: sessionToken }
    } = signInUserSession;
    setSocialToken({ sessionToken, refreshToken, deviceKey });
    return getUser();
}
export const saveSessions = (signInUserSession: SignInUserSession): { sessionToken: string, refreshToken: string, deviceKey: string } => {
    const {
        idToken: { jwtToken: deviceKey },
        refreshToken: { token: refreshToken },
        accessToken: { jwtToken: sessionToken }
    } = signInUserSession;
    setSocialToken({ sessionToken, refreshToken, deviceKey });
    return { sessionToken, refreshToken, deviceKey };
}
/**
 * Devuelve los tokens de la sesión
 * @returns {Promise<CognitoUserSession>} Devuelve una promesa con la interfaz SignInUserSession
 */
export const getUser = (): Promise<SignInUserSession | any> => {
    return Auth.currentSession();
}
export const signOutCognitoUser = (): Promise<any> => {
    return Auth.signOut();
}
export const getPromiseByProvider = (provider: string) => {
    saveCurrentPage();
    switch (provider) {
        case 'google': return Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google });
        case 'facebook': return Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Facebook });
        case 'apple': return Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Apple });
    }
}

export const fetchCognitoUserStatus = (): Promise<any> => {
    return Auth.currentSession()
        .then(user => user && !isEmptyObject(user))
        .catch(() => { return false })
}
export const getSocialToken = () => {
    return getToken();
}


const saveCurrentPage = () => {
    const url = window.location.pathname.split('/app/').filter(item => item != '');
    const currentPage = url[0];
    switch (currentPage) {
        case 'login': sessionStorage.setItem('current-page', '/plan'); break;   // login social desde la pantalla /login
        case 'trip': sessionStorage.setItem('current-page', '/trip'); break;    // login social desde la pantalla /trip
        default: sessionStorage.setItem('current-page', '/plan'); break;  // login social desde la HOME principal
    }
}
/* Private functions */
const setSocialToken = ({ sessionToken, refreshToken, deviceKey }: SocialTokens) => {
    setStorage({ sessionToken, refreshToken, deviceKey })
}


export async function refreshTokenSocial() {
    try {
        await Auth.currentSession();
        const user = await Auth.currentAuthenticatedUser();
        const refreshToken = user.signInUserSession.refreshToken.token;
        // Llama a Auth para refrescar el token
        const newSession = await Auth.currentSession() as any;
        const newAccessToken = newSession.getAccessToken().getJwtToken();
        const result={
            data:newAccessToken
        }

        let map={
                deviceKey:newSession.accessToken.jwtToken,
                sessionToken:newAccessToken,
                refreshToken:newSession.refreshToken.token
        }

        //saveSessions(newSession) as RaaSSession;
        setStorage(map)
        //setToken(newAccessToken)
        return result;
    } catch (error) {
        console.error('Error refreshing session:', error);
        // Maneja el error, por ejemplo, redirigiendo al usuario a la pantalla de login
    }
}